<template>
  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-toolbar flat color="white" class="mb-3">
        <v-tooltip bottom>
          <v-btn icon @click="$router.go(-1)" slot="activator">
            <v-icon color="white">arrow_back</v-icon>
          </v-btn>

          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>

        <v-toolbar-title>
          {{ $vuetify.t('$vuetify.forms.index_title') }}
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>
    </v-flex>
    <v-flex xs12 sm12>
      <v-list two-line>
        <template>
          <v-list-tile
            v-for="(form, index) in this.formTemplates"
            :key="'form' + index"
            avatar
            :to="{ path: '/form/' + form.slug }"
          >
            <v-list-tile-avatar>
              <v-icon color="blue">poll</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="form.name"></v-list-tile-title>
              <v-list-tile-sub-title
                v-if="form.description"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data: () => ({
    render: '',
    componentKey: 0,
    formTemplates: []
  }),
  mounted() {
    this.getForms()
  },
  methods: {
    ...mapActions({
      fetchForms: 'calls/fetchForms'
    }),
    getForms: function() {
      this.formTemplates = this.getActiveCall.form_templates
    }
  },
  computed: {
    ...mapState({
      forms: state => state.calls.forms
    }),
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall'
    })
  }
}
</script>
